import React, { useState } from 'react';
import { KioskPublishType, ReduxState, PortalDetail } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { Button, TextField } from '@material-ui/core';
import './connectserver.style.scss';
import logo from '../../../../assets/images/logo/logo50_k.png';
import { Link } from 'react-router-dom';
import { API, RoutePath } from '../../../../data';
import { get } from 'scripts/api';
import { kioskCode, kioskData, portalData } from 'scripts/storage';
import { setKioskData, setPortalPublishData } from 'redux/actions';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import { newPortalToPortal, publishDetailToPublish } from 'ucheck/ucheck.scripts';

const Connecter: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang.signin.connectServer;
    const [input, setInput] = useState<string | undefined>(undefined);
    const [load, setLoad] = useState(false);
    const [isPortal, setPortal] = useState(false);

    function connectHandler() {
        if (!input) return;
        setLoad(true);
        if (isPortal) {
            get<PortalDetail>(API.register.getPortalByCode(input))
                .then((res) => {
                    const portal = newPortalToPortal(res.data);
                    portalData.set(portal);
                    kioskCode.set(Number(input));
                    props.dispatch(setPortalPublishData(portal));
                })
                .catch((res) => {
                    if (res.status >= 500) toast.error(props.lang.serverErr);
                    else if (res.status >= 400) toast.error(lang.error);
                    else toast.error(props.lang.unknownErr);
                })
                .finally(() => setLoad(false));
        } else {
            get<KioskPublishType>(API.register.getByCode(input))
                .then((res) => {
                    const publish = publishDetailToPublish(res.data);
                    kioskData.set(publish);
                    kioskCode.set(Number(input));
                    props.dispatch(setKioskData(publish));
                })
                .catch((res) => {
                    if (res.status >= 500) toast.error(props.lang.serverErr);
                    else if (res.status >= 400) toast.error(lang.error);
                    else toast.error(props.lang.unknownErr);
                })
                .finally(() => setLoad(false));
        }
    }
    return (
        <div className="signin-connect-server">
            <div className="image-div">
                <img className="logo" src={logo} alt="logo" />
            </div>
            <TextField
                type="number"
                className="input"
                id="standard-full-width"
                placeholder={lang.inputPH}
                fullWidth
                margin="normal"
                onChange={(e) => setInput(e.target.value)}
            />
            <div className="portal-check">
                <input onChange={(e) => setPortal(e.target.checked)} id="portal-sign-up-checkbox" type="checkbox" />
                <label htmlFor="portal-sign-up-checkbox">{lang.enterPortal}</label>
            </div>
            <div className="button-div">
                <Button
                    onClick={connectHandler}
                    className="enter-button"
                    variant="contained"
                    color="primary"
                    disableElevation
                    disabled={!input || load}
                >
                    {load ? <Spinner animation="border" /> : lang.connect}
                </Button>
            </div>
            <div className="end-line">
                <p className="question">{lang.question}</p>
                <span />
                <Link to={RoutePath.register.signIn.form} className="enter-kiosk">
                    {lang.enterAsker}
                </Link>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(Connecter);
